export type { ConsentHandler, ConsentSnapshot, ConsentStatus } from './types';
export { CONSENT_COOKIE_NAME, readConsentFromCookieHeader } from './cookie';
export { decide, getConsent, hydrate } from './store';
export { closeConsentPrompt, openConsentPrompt, useConsentPromptOpen } from './prompt';
export { registerConsentHandler } from './registry';
export { useConsent } from './useConsent';
export type { UseConsentResult } from './useConsent';
export { useConsentHandler } from './useConsentHandler';
